import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
// import OperatorEdit from './operator-edit'
import ProfileList from './profile-list'
import ProfileAdd from './profile-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Profile = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.PROFILE}
                        component={ProfileList}
                    />
                    {/* <Route
                        exact
                        path={ROUTES.OPERATOR_EDIT}
                        component={OperatorEdit}
                    /> */}
                    <Route
                        exact
                        path={ROUTES.PROFILE_ADD}
                        component={ProfileAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Profile)



// WEBPACK FOOTER //
// ./src/pages/profile/index.js